(function () {
  const initAnimation = (section) => {
    if (!section || !section.querySelector(".animate-on-scroll")) return;

    const footerBlocksContainer = section.querySelector(".footer-blocks");

    if (!footerBlocksContainer) return;

    const footerBlocks = footerBlocksContainer.querySelectorAll(
      ".footer-block, .accordion"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          // COY: native browser animation (same 1.75s mask sweep) so the 72KB gsap library
          // no longer has to load on every page just for the footer.
          const clearMask = (block) => {
            block.style.webkitMaskImage = "none";
            block.style.maskImage = "none";
          };
          footerBlocks.forEach((block) => {
            if (typeof block.animate !== "function") {
              clearMask(block);
              return;
            }
            try {
              const anim = block.animate(
                [
                  { maskPosition: "100% 0%", webkitMaskPosition: "100% 0%" },
                  { maskPosition: "0% 0%", webkitMaskPosition: "0% 0%" },
                ],
                {
                  duration: 1750,
                  easing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                  fill: "forwards",
                }
              );
              anim.onfinish = () => clearMask(block);
              anim.oncancel = () => clearMask(block);
            } catch (e) {
              clearMask(block);
            }
          });
          observer.disconnect();
        }
      },
      {
        threshold: 0,
      }
    );

    observer.observe(footerBlocksContainer);
  };

  initAnimation(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initAnimation(event.target);
  });
})();
